import { http, ResponseWrapper } from 'webPosApp/api';
import StoreModel from 'webPosApp/models/Index';

export class Billpay {
    customer?: BillpayResponse | null;
    private root: StoreModel;

    constructor(root: StoreModel) {
        this.root = root;
    }

    getCustomerData = async (
        request: BillpayRequest
    ): Promise<ResponseWrapper<BillpayResponse>> => {
        const response = await http.post<ResponseWrapper<BillpayResponse>>(
            'api/optimum/billpay',
            request
        );

        this.customer = new BillpayResponse(response.data);

        return response.data;
    };

    reset() {
        this.customer = null;
    }    
}

export interface BillpayRequest {
    accountNumber: string | undefined;
    zip: string | undefined;

    mobileNumber: string | undefined;
}

export class BillpayResponse {
    accountNumber: string;

    amountDue: number;
    currentBalance: number;
    pastDueAmount: number;

    constructor(value: any) {
        this.accountNumber = value.accountNumber;
        this.amountDue = value.amountDue || 0;
        this.pastDueAmount = value.pastDueAmount || 0;

        /**
         * Amdocs logic for currentBalance  always include pastDueAmount
         * Therefore real current balance is  {currentBalance – pastDueAmount}
         * see https://b2bsoft.atlassian.net/browse/CRT-1794
         */
        this.currentBalance = value.currentBalance - value.pastDueAmount || 0;
    }

    get totalDueAmount(): number {
        return this.pastDueAmount + this.currentBalance;
    }
}
